import { createMachine, assign } from 'xstate';
import { sendParent } from 'xstate/lib/actions';

import { EVENTS } from '../constants/analtyics-events';

const authMachine =
  /** @xstate-layout N4IgpgJg5mDOIC5QEMCuAXAFgOlgSygDtIBJQ7AJzADMrZM9CoAVAewGsxCBiCV47IwBuHMNjRZcBYhDKUadBkzadCCYawDGydHn4BtAAwBdI8cSgADq3y7+FkAA9EAWgAcAFgDM2NwDYvAHYAVkCAvwBGAE4-ABoQAE9XD0NsACY0ww8ojzdA-Ki3NIBfYviJHHwiUnIqWjglFlEeMAoKVgpsSwAbHWoOgFtxDErpGvl6+kYm1XVCEW07QjMzB2tbPUIHZwQXPz9A7Ajcw0CvUMNT0Pik3ZzfQz83L0f8tOf-UvKRqWrZck0-CErV0ylYAAVWgNkMRCOgAIKaQGoOHcABKAFFwQB5NHMAD6AFVwQBxNHwgAiGPxzGx+PBGLRAFl4QA5DGsgmEgDKjNWSBA6zwS22rgiaWwfkMmUK0Q80VC0RuyTcXxAFV+MjkgPmIOmbEhFGhsIRSNYKPQ6KxuK5pPJVJpdIZzLZHK5vLR+IAYvCSAAZQmY-lWGzCzai3a5Q5pILePzBbIRMLK3bBNwPR7BCKPRORDx+NUaqpanjckgk1n47GE5jBwWhkUCnYuY5eDzYNsxQIpMIpYIplxt7AeDzBLw5Lz+KJtvw5Qs-Ys1bgAYWxrIAaoyCbT6YyWezOfj4cvV4TOXWhY3QM35VEjtO3IZ-F4YzHRwOXunCu8ioFnjKInnSRF3+bgSQxAkSApR0AGkOQvBtwybVwQh8D4pRCeNgh-D8n2wb8ojSJ5PGOQJALKdUF2kaZsQwK0cTxfEywrKsawQjZ7GQ3YXmidJsx7UiE2OFMvAiYJsGCYJ43eNJvFkjwgNGP5aMtXlWWg5jKxISs-W0mDHXxDEWX9diw0469XHeQpsBCfMohCR83ByOJEkQUIJVE4JLjyFIAm8RTNUgFTuE0-FtPxAB1EhmAACUM4y-XxXTWRg0yrycSzRx8NMInFP8MkCK4BzE9M-FHQws1OAI3DE4IApA4LQvCtk1wATSZatuT9Vq0qQizuKTPx0gyCIXkuJ8Xn7VyEDI8TvBqg4InjNwpPqsYIEa8stMrKLYvxZceVpJlYPgkw1kQ8yMu4jwQmHcc0kk-ibrcFNZruhayOWySojW5S6Ka1lesu5s0iTCIJNy8VRzyA4pNesJsEuNNvzKzwx1+mRNpY6tazOgVLz6q7By8c58NfWSwlBjIU1CI4JqW7DDDy0IAs0TAwE0dhpi9DpuWkQlLAxaE8G6Xh+DEDROGGSQ2Y5rmmB5ig+aIAWheQEW5gWHRNhWPGQw4rYuJcTIUgkpnCNCF8HoTD9QcR6V3jTQwoiyIoCwojVZc57nef5wXhdF1p2k6Ho+kGaWcC9+WoEV5XCFVgPNa0bWDBMIHDf642iIlKJCNeMSZwiAcnOHCrDBeKynJiLx6q4CBpjjsg-UYdg2DVkX6JteLfUSgGkr0piOQpdOIxbcU7zHaIogTSS0mnFzbgyL8KvjaVAge+Ma49hc64b6Qm5btuA87xijJ7pitrCnSB7U6CfX9QMMRHo2SolKnRylU58hfFMl-wlenzij8O8JmW9vjAWokwMgEVhSYHbt0ZuhB2AnwJGff0-cUoXxYtpZ+mdRoBF8Pkde3ZojmymrcY2okOxMyeJJeUTlsgY2mNA2B8DEHIMxAxVBCUMH6T7vfAMQY9b1gNqPIi8YbLl0fJ+QIuc0wiTEhJKS2EihyRHEwqBhB4SEH4AkAY5pYDdASCgo8rI2odR5Fg7auCiaeDQuXKI2ZjhST-B4FMBxDhJnLmObIUlFoaKgGQbRuj9GoEMcYzhXcWqsnap1KxV9vQ90fjYkGTNxIkyzMAicTlrjTRcb4GMZVc4hBUaqbeECiDMMIDArAy4wnoFYAMFQXATEHW5EdE6lYAYpMsu8cG2QDj7H8FkQiaQUzZnHL4IBskiLrwCGAyiFTCBVJqZgOpsAGlNOaK0w62Jjq0jgl0y+4UBHJOEQTYGrgXy5Hwk5SI+xfIfxTJ4IaucXayiCMEeygQAlkBMd085F0M5EwTB5XKj4AhLQmlEV61l4w5GePnPIJQ1Q6IgHABwRZ1pyDwBAboYBzqiKNmEVIM4PhkU+kqaaMQMbjDqIofUzRCVmWBc2SmRwnYERqtKAcMZwY1TbFkfYJM+kLKxX8bUQI9RgkNMaLgppkRwmZelEGQQbKFUeLOEcCp17FWnJKUSslDWSSIWU8BSkSzKsJs2Jy-KAghDCF4SIMQBwjnEt+WRaRUKFT-AElSVrLm7AyC8YcCZgEfyzKJLw4zxKhEkm2F81dJwJlpRtDAAbWVXKCB5LIXqEzZCCP4GmNzRLZHsr+Oek5Wbs29grX2Kt-bq26BmsRLw7xZDOKvMuMZyFXNHPbJe+xQYpE8LXQg9cmCN0IOwo+TaW0vxfJ46UCZp7lWzAvRACNs6XCHWEWU7tzWahWawgO7D514JCBKMcRE3CeHlEzEcvLp7DiyqccFHhs6-K0TowgeiDFGPPUTBUEpgEHEfA7Zd0bpqXvtk7UchVkZ1XKRa49tT6mNOacCi5mag32R8GVUS2YvWDPjOM8u7Y55PEnEM6IQQv2AZBhkdshUVqPEuHPQaKZHFfkfF8nicySaKQY1c7CPhvAW0qiOP8A4fG3PeB+v8y1pSlFKEAA */
  createMachine(
    {
      context: { user: undefined, error: undefined, token: undefined },
      preserveActionOrder: true,
      predictableActionArguments: true,
      id: 'auth',
      initial: 'signedOut',
      states: {
        signedIn: {
          entry: 'assignUserToContext',
          initial: 'idle',
          states: {
            idle: {},
            refreshingToken: {
              invoke: {
                src: 'refreshToken',
                onDone: [
                  {
                    target: 'idle',
                  },
                ],
                onError: [
                  {
                    target: 'idle',
                  },
                ],
              },
            },
            convertingToPermanentAccount: {
              invoke: {
                src: 'convertToPermanentAccount',
              },
              on: {
                REPORT_UPGRADE_TO_PERMANENT_USER: {
                  target: 'idle',
                  actions: [
                    'assignUserToContext',
                    'reportAnonymousUserUpgrade',
                    'ackAnonymousUserUpgrade',
                  ],
                },
                REPORT_UPGRADE_TO_PERMANENT_USER_FAILURE: {
                  target: 'idle',
                  actions: [
                    'assignErrorToContext',
                    'ackAnonymousUserUpgradeFailure',
                  ],
                },
              },
            },
          },
          on: {
            SIGN_OUT: {
              target: 'signingOut',
            },
            CONVERT_TO_PERMANENT_ACCOUNT: {
              target: '.convertingToPermanentAccount',
            },
            GET_ID_TOKEN: {
              target: '.refreshingToken',
            },
          },
        },
        signingOut: {
          invoke: {
            src: 'signOut',
          },
          on: {
            REPORT_SIGN_OUT: {
              target: 'signedOut',
              actions: ['clearUserFromContext', 'reportSignOut'],
            },
          },
        },
        signedOut: {
          exit: 'clearErrorFromContext',
          on: {
            SEND_SIGN_IN_LINK_TO_EMAIL: {
              target: 'sendingSignInLinkToEmail',
            },
            SIGN_IN_WITH_EMAIL_LINK: {
              target: 'checkingForSignUpEmail',
            },
            SIGN_IN_ANONYMOUSLY: {
              target: 'signingInAnonymously',
            },
            SIGN_IN_WITH_CUSTOM_TOKEN: {
              target: 'signingInWithCustomToken',
            },
            SIGN_IN: {
              target: 'signingIn',
            },
            SIGN_OUT: {
              target: 'signingOut',
            },
          },
        },
        checkingForSignUpEmail: {
          invoke: {
            src: 'checkForSignUpEmail',
            onDone: [
              {
                target: 'signingInWithEmailLink',
              },
            ],
            onError: [
              {
                target: 'signedOut',
              },
            ],
          },
        },
        sendingSignInLinkToEmail: {
          invoke: {
            src: 'sendSignInLinkToEmail',
          },
          on: {
            REPORT_EMAIL_SIGN_IN_LINK_SEND: {
              target: 'signedOut',
              actions: ['reportEmailSignInLinkSend', 'ackEmailSignInLinkSend'],
            },
            REPORT_EMAIL_SIGN_IN_LINK_SEND_FAILURE: {
              target: 'signedOut',
              actions: [
                'assignErrorToContext',
                'ackEmailSignInLinkSendFailure',
              ],
            },
          },
        },
        signingInWithEmailLink: {
          invoke: {
            src: 'signInWithEmailLink',
          },
          on: {
            REPORT_EMAIL_LINK_SIGN_IN: {
              target: 'signedIn',
              actions: ['assignUserToContext', 'reportEmailLinkSignIn'],
            },
            REPORT_EMAIL_LINK_SIGN_IN_FAILURE: {
              target: 'signedOut',
              actions: ['clearUserFromContext', 'assignErrorToContext'],
            },
          },
        },
        signingInAnonymously: {
          invoke: {
            src: 'signInAnonymously',
          },
          on: {
            REPORT_ANONYMOUS_SIGN_IN: {
              target: 'signedIn',
              actions: [
                'assignUserToContext',
                'reportAnonymousSignIn',
                'ackAnonymousSignIn',
              ],
            },
            REPORT_ANONYMOUS_SIGN_IN_FAILURE: {
              target: 'signedOut',
              actions: [
                'clearUserFromContext',
                'assignErrorToContext',
                'ackAnonymousSignInFailure',
              ],
            },
          },
        },
        signingInWithCustomToken: {
          invoke: {
            src: 'signInWithCustomToken',
          },
          on: {
            REPORT_CUSTOM_TOKEN_SIGN_IN: {
              target: 'signedIn',
              actions: [
                'assignUserToContext',
                'reportCustomTokenSignIn',
                'ackCustomTokenSignIn',
              ],
            },
            REPORT_CUSTOM_TOKEN_SIGN_IN_FAILURE: {
              target: 'signedOut',
              actions: [
                'clearUserFromContext',
                'assignErrorToContext',
                'ackCustomTokenSignInFailure',
              ],
            },
          },
        },
        signingIn: {
          invoke: {
            src: 'signIn',
          },
          on: {
            REPORT_SIGN_IN: {
              target: 'signedIn',
              actions: 'assignUserToContext',
            },
          },
        },
      },
    },
    {
      guards: {},
      services: {
        refreshToken: (context, event) => {
          const { getIdToken } = event.payload.bundle;
          return getIdToken(context.user);
        },
        sendSignInLinkToEmail: (_context, event) => (send) => {
          const auth = event.payload.instance;
          const [{ email, actionCodeSettings }] = event.payload.arguments;
          const { fromId } = event.payload;

          const { sendSignInLinkToEmail } = event.payload.bundle;

          sendSignInLinkToEmail(auth, email, actionCodeSettings)
            .then(() => {
              window.localStorage.setItem('emailForSignIn', email);
            })
            .then(() => {
              send({ type: 'REPORT_EMAIL_SIGN_IN_LINK_SEND', fromId });
            })
            .catch((error) => {
              send({
                type: 'REPORT_EMAIL_SIGN_IN_LINK_SEND_FAILURE',
                error,
                fromId,
              });
            });
        },
        checkForSignUpEmail: (_context, event) => {
          const { isSignInWithEmailLink } = event.payload.bundle;
          const auth = event.payload.instance;

          if (isSignInWithEmailLink(auth, window.location.href)) {
            let email = window.localStorage.getItem('emailForSignIn');

            if (!email) {
              email = window.prompt(
                'Please provide your email for confirmation',
              );
            }

            return Promise.resolve({
              payload: event.payload,
              emailForSignIn: email,
            });
          }

          return Promise.reject();
        },
        signInWithEmailLink: (_context, event) => (send) => {
          const { emailForSignIn } = event.data;
          const { signInWithEmailLink } = event.data.payload.bundle;

          const auth = event.data.payload.instance;

          signInWithEmailLink(auth, emailForSignIn, window.location.href)
            .then((credential) => {
              window.localStorage.removeItem('emailForSignIn');
              send({
                type: 'REPORT_EMAIL_LINK_SIGN_IN',
                user: credential.user,
              });
            })
            .catch((error) => {
              send({ type: 'REPORT_EMAIL_LINK_SIGN_IN_FAILURE', error });
            });
        },
        signInAnonymously: (_, event) => (send) => {
          const auth = event.payload.instance;
          const { signInAnonymously } = event.payload.bundle;
          const { fromId } = event.payload;

          signInAnonymously(auth)
            .then((credential) => {
              send({
                type: 'REPORT_ANONYMOUS_SIGN_IN',
                user: credential.user,
                fromId,
              });
            })
            .catch((error) => {
              send({ type: 'REPORT_ANONYMOUS_SIGN_IN_FAILURE', error, fromId });
            });
        },
        signInWithCustomToken: (_context, event) => (send) => {
          const auth = event.payload.instance;
          const [{ token }] = event.payload.arguments;
          const { signInWithCustomToken } = event.payload.bundle;
          const { fromId } = event.payload;

          signInWithCustomToken(auth, token)
            .then((credential) => {
              send({
                type: 'REPORT_CUSTOM_TOKEN_SIGN_IN',
                user: credential.user,
                fromId,
              });
            })
            .catch((error) => {
              send({
                type: 'REPORT_CUSTOM_TOKEN_SIGN_IN_FAILURE',
                error,
                fromId,
              });
            });
        },
        convertToPermanentAccount: (context, event) => (send) => {
          const [{ email, password }] = event.payload.arguments;
          const { EmailAuthProvider, linkWithCredential } =
            event.payload.bundle;

          const { fromId } = event.payload;

          const credential = EmailAuthProvider.credential(email, password);

          linkWithCredential(context.user, credential)
            .then((credential) => {
              send({
                type: 'REPORT_UPGRADE_TO_PERMANENT_USER',
                user: credential.user,
                fromId,
              });
            })
            .catch((error) => {
              send({
                type: 'REPORT_UPGRADE_TO_PERMANENT_USER_FAILURE',
                error,
                fromId,
              });
            });
        },
        signOut: (_context, event) => (send) => {
          const { bundle, instance } = event.payload;

          if (instance && instance.currentUser !== null) {
            bundle.signOut(instance).then(() => {
              send({ type: 'REPORT_SIGN_OUT' });
            });
          } else {
            send({ type: 'REPORT_SIGN_OUT' });
          }
        },
        signIn: (_, event) => (send) => {
          const [{ user }] = event.payload.arguments;

          send({ type: 'REPORT_SIGN_IN', user });
        },
      },
      actions: {
        ackEmailSignInLinkSend: sendParent((_context, event) => {
          return {
            type: 'SERVICE.CALL',
            serviceId: event.fromId,
            event: 'ACK_EMAIL_SIGN_IN_LINK_SEND',
            arguments: [],
          };
        }),
        ackEmailSignInLinkSendFailure: sendParent((_context, event) => {
          return {
            type: 'SERVICE.CALL',
            serviceId: event.fromId,
            event: 'ACK_EMAIL_SIGN_IN_LINK_SEND_FAILURE',
            arguments: [],
          };
        }),
        ackAnonymousSignIn: sendParent((_context, event) => {
          return {
            type: 'SERVICE.CALL',
            serviceId: event.fromId,
            event: 'ACK_ANONYMOUS_SIGN_IN',
            arguments: [],
          };
        }),
        ackAnonymousSignInFailure: sendParent((_context, event) => {
          return {
            type: 'SERVICE.CALL',
            serviceId: event.fromId,
            event: 'ACK_ANONYMOUS_SIGN_IN_FAILURE',
            arguments: [],
          };
        }),
        ackAnonymousUserUpgrade: sendParent((_context, event) => {
          return {
            type: 'SERVICE.CALL',
            serviceId: event.fromId,
            event: 'ACK_ANONYMOUS_USER_UPGRADE',
            arguments: [],
          };
        }),
        ackAnonymousUserUpgradeFailure: sendParent((_context, event) => {
          return {
            type: 'SERVICE.CALL',
            serviceId: event.fromId,
            event: 'ACK_ANONYMOUS_USER_UPGRADE_FAILURE',
            arguments: [],
          };
        }),
        ackCustomTokenSignIn: sendParent((_context, event) => {
          return {
            type: 'SERVICE.CALL',
            serviceId: event.fromId,
            event: 'ACK_CUSTOM_TOKEN_SIGN_IN',
            arguments: [],
          };
        }),
        ackCustomTokenSignInFailure: sendParent((_context, event) => {
          return {
            type: 'SERVICE.CALL',
            serviceId: event.fromId,
            event: 'ACK_CUSTOM_TOKEN_SIGN_IN_FAILURE',
            arguments: [],
          };
        }),
        reportEmailSignInLinkSend: sendParent({
          type: 'SERVICE.CALL',
          serviceId: 'analytics',
          event: 'LOG_EVENT',
          arguments: [EVENTS.MAGIC_LINK_SEND, {}, {}],
        }),
        reportEmailLinkSignIn: sendParent({
          type: 'SERVICE.CALL',
          serviceId: 'analytics',
          event: 'LOG_EVENT',
          arguments: [EVENTS.LOG_IN, { method: 'google:magiclink' }, {}],
        }),
        reportAnonymousSignIn: sendParent({
          type: 'SERVICE.CALL',
          serviceId: 'analytics',
          event: 'LOG_EVENT',
          arguments: [EVENTS.LOG_IN, { method: 'google:anonymous' }, {}],
        }),
        reportCustomTokenSignIn: sendParent({
          type: 'SERVICE.CALL',
          serviceId: 'analytics',
          event: 'LOG_EVENT',
          arguments: [EVENTS.LOG_IN, { method: 'google:customtoken' }, {}],
        }),
        reportSignOut: sendParent({
          type: 'SERVICE.CALL',
          serviceId: 'analytics',
          event: 'LOG_EVENT',
          arguments: [EVENTS.LOG_OUT, {}, {}],
        }),
        reportAnonymousUserUpgrade: sendParent({
          type: 'SERVICE.CALL',
          serviceId: 'analytics',
          event: 'LOG_EVENT',
          arguments: [EVENTS.ANONYMOUS_USER_UPGRADE, {}, {}],
        }),
        assignUserToContext: assign({
          user: (_context, event) => {
            return event.user;
          },
          error: undefined,
        }),
        assignErrorToContext: assign({
          error: (_context, event) => {
            return event.error;
          },
        }),
        clearUserFromContext: assign({
          user: null,
        }),
        clearErrorFromContext: assign({
          error: undefined,
        }),
      },
    },
  );

export default authMachine;
